document.addEventListener('DOMContentLoaded', function () {

    // ---------------------------------------------------------------------------
    // CONFIGURACIÓN DE MAPAS
    // clave     = name del campo destino (facturación / envío)
    // vendedor  = name del campo fuente del vendedor
    // comprador = name del campo fuente del comprador
    // ---------------------------------------------------------------------------
    var camposFacturacion = {
        'email_facturacion':        { vendedor: 'email_vendedor',        comprador: 'email_comprador' },
        'razon_social_facturacion': { vendedor: 'razon_social_vendedor', comprador: 'razon_social_comprador' },
        'direccion_facturacion':    { vendedor: 'direccion_vendedor',    comprador: 'direccion_comprador' },
        'nif_facturacion':          { vendedor: 'nif_vendedor',          comprador: 'nif_comprador' },
        'poblacion_facturacion':    { vendedor: 'poblacion_vendedor',    comprador: 'poblacion_comprador' },
        'provincia_facturacion':    { vendedor: 'provincia_vendedor',    comprador: 'provincia_comprador' },
        'cp_facturacion':           { vendedor: 'cp_vendedor',           comprador: 'cp_comprador' },
        'pais_facturacion':         { vendedor: 'pais_vendedor',         comprador: 'pais_comprador' },
    };

    var camposEnvio = {
        'nombre_completo_envio': { vendedor: 'razon_social_vendedor', comprador: 'razon_social_comprador' },
        'direccion_envio':       { vendedor: 'direccion_vendedor',    comprador: 'direccion_comprador' },
        'cp_envio':              { vendedor: 'cp_vendedor',           comprador: 'cp_comprador' },
        'poblacion_envio':       { vendedor: 'poblacion_vendedor',    comprador: 'poblacion_comprador' },
        'provincia_envio':       { vendedor: 'provincia_vendedor',    comprador: 'provincia_comprador' },
        'pais_envio':            { vendedor: 'pais_vendedor',         comprador: 'pais_comprador' },
    };

    // ---------------------------------------------------------------------------
    // Obtiene el valor del Advanced Choice Field buscando el input:checked
    // dentro del .jet-form-builder-choice--item con clase is-checked
    // (JFB no actualiza el input.value directamente; gestiona la selección
    //  via la clase is-checked en el <li> y el atributo checked en el radio)
    // ---------------------------------------------------------------------------
    function getChoiceValue(fieldName) {
        // Primero: buscar dentro del li marcado con is-checked
        var checkedLi = document.querySelector(
            '.jet-form-builder-choice--item.is-checked [name="' + fieldName + '"]'
        );
        if (checkedLi) return checkedLi.value;

        // Fallback: input radio nativo con checked
        var radioChecked = document.querySelector('[name="' + fieldName + '"]:checked');
        if (radioChecked) return radioChecked.value;

        return null;
    }

    // ---------------------------------------------------------------------------
    // Copia los valores del origen al destino según el mapa y la fuente elegida
    // ---------------------------------------------------------------------------
    function sincronizarCampos(fieldName, mapaConfig) {
        var fuente = getChoiceValue(fieldName);
        if (!fuente || fuente === 'manual') return;

        Object.keys(mapaConfig).forEach(function (idDestino) {
            var idOrigen = mapaConfig[idDestino][fuente];
            if (!idOrigen) return;

            var elOrigen  = document.querySelector('[name="' + idOrigen + '"]');
            var elDestino = document.querySelector('[name="' + idDestino + '"]');

            if (elOrigen && elDestino) {
                elDestino.value = elOrigen.value;
                elDestino.dispatchEvent(new Event('input',  { bubbles: true }));
                elDestino.dispatchEvent(new Event('change', { bubbles: true }));
            }
        });
    }

    // ---------------------------------------------------------------------------
    // Observa los <li> del Advanced Choice Field con MutationObserver
    // y dispara la sincronización cuando el <li> recibe la clase is-checked
    // (mismo patrón que catalogos-vehiculos.js)
    // ---------------------------------------------------------------------------
    function watchChoiceField(fieldName, callback) {
        var items = document.querySelectorAll('.jet-form-builder-choice--item');
        var found = false;

        items.forEach(function (li) {
            if (!li.querySelector('[name="' + fieldName + '"]')) return;
            found = true;

            new MutationObserver(function (mutations) {
                mutations.forEach(function (mut) {
                    if (mut.attributeName === 'class' && li.classList.contains('is-checked')) {
                        callback();
                    }
                });
            }).observe(li, { attributes: true });
        });

        return found;
    }

    // ---------------------------------------------------------------------------
    // Intenta registrar los watchers; si JFB aún no renderizó los <li>,
    // espera con un MutationObserver sobre el body
    // ---------------------------------------------------------------------------
    function tryRegisterWatchers() {
        var items      = document.querySelectorAll('.jet-form-builder-choice--item');
        var hasFact    = Array.from(items).some(function (li) { return li.querySelector('[name="elegir_fuente_facturacion"]'); });
        var hasEnvio   = Array.from(items).some(function (li) { return li.querySelector('[name="elegir_fuente_envio"]'); });

        if (hasFact) {
            watchChoiceField('elegir_fuente_facturacion', function () {
                sincronizarCampos('elegir_fuente_facturacion', camposFacturacion);
            });
        }

        if (hasEnvio) {
            watchChoiceField('elegir_fuente_envio', function () {
                sincronizarCampos('elegir_fuente_envio', camposEnvio);
            });
        }

        return hasFact || hasEnvio;
    }

    if (!tryRegisterWatchers()) {
        var obs = new MutationObserver(function () {
            if (tryRegisterWatchers()) obs.disconnect();
        });
        obs.observe(document.body, { childList: true, subtree: true });
    }

    // ---------------------------------------------------------------------------
    // Re-sincronización en vivo: si el usuario edita campos del vendedor/comprador
    // después de haberlos copiado, los destinos se actualizan automáticamente
    // ---------------------------------------------------------------------------
    document.addEventListener('input', function (e) {
        var name = e.target.name;
        if (!name) return;

        if (name.includes('_vendedor') || name.includes('_comprador')) {
            sincronizarCampos('elegir_fuente_facturacion', camposFacturacion);
            sincronizarCampos('elegir_fuente_envio', camposEnvio);
        }
    });
});



// WEBPACK FOOTER //
// ./scripts/formularios-itp/form-sync-fields.js